<template>
  <div class="category-setting">
    <p>此模块只设置分类在页面中的展示位置，可拖动调整位置。</p>
    <p>分类内容请返回「店铺装修」列表，点击当前微页面的「分类配置」。</p>
    <p>删除此展示模块不会删除分类配置，小程序分类页仍然可以使用。</p>
  </div>
</template>
<script>
export default { name: 'CategoryGoodsSetting' }
</script>
<style scoped>
.category-setting { padding: 16px; color: #909399; line-height: 1.8; }
</style>
